












































































































































































































































































import { Component, Vue, Prop, Watch, Emit, Mixins } from "vue-property-decorator";
import { namespace, Getter, Action } from "vuex-class";
import { validationMixin } from "vuelidate";
import { required, requiredIf, minValue, maxValue, numeric } from "vuelidate/lib/validators";
import { EventRecord, MaskReason } from "@/store/site-monitor/types";
import vSelect from "vue-select";
import DatePicker from "@sureview/vuejs-datepicker";
import moment from "moment";
import api from "../../services/api.service";
import { retry } from "rxjs/operators";
import { UserPermissions, FeaturesList, Region } from "@/store/types";
import { get } from "lodash";

const siteMonitor = namespace("siteMonitor");

class DisarmRequest {
	responseID: number | null;
	groupID: number | null;
	eventID: number | null;
	disarmReasonID: number | null;
	reason: any;
	hours: number | null;
	minutes: number | null;
	maskDate: Date;
	date: string;
	maskType: number;
	time: string;
}

@Component({
	mixins: [validationMixin],
	validations: {
		alarmMaskRequest: {
			reason: {
				required: requiredIf(function() {
					return (
						this.requireMaskReason
					);
				})
			},
			disarmNote: {
				required: requiredIf(function() {
					return (
						this.requireMaskNote
					);
				})
			},
			hours: {
				numeric,
				required: requiredIf(function() {
					return this.alarmMaskRequest.maskType == this.MaskType.MaskForPeriod;
				}),
				minValue: minValue(0),
				validateHourPermission: function(hours) {
					return hours <= this.getMaskMaxHours;
				},
				validateMaxTime: function(hours) {
					return this.getMaskMaxHours == hours && this.alarmMaskRequest.minutes > 0 ? false : true;
				}
			},
			minutes: {
				numeric,
				required: requiredIf(function() {
					return this.alarmMaskRequest.maskType == this.MaskType.MaskForPeriod;
				}),
				minValue: minValue(0),
				maxValue: maxValue(59)
			},
			maskDate: {
				required: requiredIf(function() {
					return this.alarmMaskRequest.maskType == this.MaskType.MaskUntilDate;
				}),
				minValue: minValue(new Date().setHours(0, 0, 0, 0))
			},
			time: {
				pattern: function(value) {
					if (typeof value == "undefined" || value == null || value == "") return true;
					return /^[0-9]{2}:[0-9]{2}$/.test(value);
				},
				minTime: function(value) {
					/**
					 * Validator to ensure that the time entered by the user is in the future
					 */
					if (
						typeof value == "undefined" ||
						value == null ||
						value == "" ||
						typeof this.alarmMaskRequest.maskDate == "undefined" ||
						this.alarmMaskRequest.maskDate == null ||
						this.alarmMaskRequest.maskType !== this.MaskType.MaskUntilDate
					)
						return true;

					const now = new Date().setHours(0, 0, 0, 0);
					const currentRequestDate = new Date(this.alarmMaskRequest.maskDate).setHours(0, 0, 0, 0);

					if (now == currentRequestDate) {
						// If the user has chosen today as the re-arm date, we need to make sure that the time they've
						// entered is greater than the current time.
						var momentTime = moment(value, "HH:mm", true).toDate();
						return momentTime > new Date();
					} else {
						// If the user hasn't chosen today, just make sure that the date they've entered is in the future.
						return currentRequestDate > now;
					}
				},
				required: requiredIf(function() {
					return this.alarmMaskRequest.maskType == this.MaskType.MaskUntilDate;
				})
			}
		}
	},
	components: {
		vSelect: vSelect,
		DatePicker: DatePicker
	},
	filters: {
		displayDate: function(value: Date) {
			return moment(value).format("LL LT");
		}
	}
})
export default class MaskAlarm extends Vue {
	// == Vuex == //
	@Getter("getFeaturesList") public featuresList: FeaturesList;
	@siteMonitor.Getter("groupID") groupId!: number | null;
	@siteMonitor.State("MaskReasons") maskReasons!: MaskReason[];
	@siteMonitor.Action maskAlarm: any;
	@Getter getMaskMaxHours: number;

	@Prop() eventId!: number;
	@Prop() responseId!: number;
	@Prop() maskedAlarm!: any;
	@Prop({ default: null }) public region: Region | null;

	// == Consts == //
	public Today = new Date();

	public MaskType = {
		MaskUntilNextSchedule: 0,
		MaskForPeriod: 1,
		MaskUntilDate: 2
	};

	// == Props == //
	$refs: {
		datePicker: Vue;
		reasonDropdown: any;
	};

	public submitting: boolean = false;
	public error: string = null;
	public calendarDisabledDates = {
		to: new Date(this.Today.setDate(this.Today.getDate() - 1))
	};
	public alarmMaskRequest = {
		responseID: -1,
		groupID: -1,
		eventID: -1,
		disarmReasonID: null,
		reason: null,
		disarmNote: null,
		hours: null,
		minutes: null,
		maskDate: new Date(),
		date: null,
		maskType: 1,
		time: moment()
			.add({ minutes: 1 })
			.format("HH:mm")
	} as DisarmRequest;

	// == Computed props == //

	/**
	 * Returns true if the alarm this popover represents has already been masked.
	 */
	public get masked() {
		return this.maskedAlarm != null && !this.maskedAlarm.armed;
	}

	public get maskedReason() {
		if (this.maskedAlarm.disarmReasonID) {
			let disarmReasons = this.maskReasons.filter(
				reason => reason.disarmReasonID == this.maskedAlarm.disarmReasonID
			);
			if (disarmReasons.length > 0) return disarmReasons[0].title;
			else return "Unknown reason";
		}

		return "";
	}

	public get requireMaskReason() {
		return get(this.featuresList, ["Alarms", "AlarmPoints", "Masking", "RequireMaskReason"]);
	}
	public get requireMaskNote() {
		return get(this.featuresList, ["Alarms", "AlarmPoints", "Masking", "RequireMaskNote"]);
	}

	/**
	 * May not be entirely required - this is just used to set the min property for the HTML5 time input,
	 * but we don't actually use HTML5 validation.
	 */
	public get minTimeForSelectedDate() {
		const today = new Date().setHours(0, 0, 0, 0);
		const defaultMinTime = "00:00";

		if (
			typeof this.alarmMaskRequest.maskDate == "undefined" ||
			this.alarmMaskRequest.maskDate == null
		) {
			return defaultMinTime;
		}

		var selectedDate = this.alarmMaskRequest.maskDate.setHours(0, 0, 0, 0);

		if (selectedDate == today) {
			return moment().format("HH:mm");
		} else {
			return defaultMinTime;
		}
	}

	// == Methods == //

	/**
	 * Formats date for the calendar input.
	 */
	calendarDateFormatter(date: string) {
		return moment(date).format("L");
	}

	reset() {
		// reset validation state and our request object
		this.$v.$reset();
		this.alarmMaskRequest = {
			responseID: this.responseId,
			eventID: this.eventId,
			disarmReasonID: null,
			reason: null,
			hours: null,
			minutes: null,
			maskDate: new Date(),
			date: null,
			maskType: this.MaskType.MaskUntilNextSchedule,
			time: moment()
				.add({ minutes: 1 })
				.format("HH:mm"),
			groupID: null
		};
	}

	/**
	 * Submits a mask request to the server.
	 *
	 * Also calculates the date the mask should be removed, if the user is performing an 'Until Date' mask.
	 */
	submitMask() {
		// set the eventID/groupID/responseID properties on our request
		this.alarmMaskRequest.responseID = this.responseId;
		this.alarmMaskRequest.eventID = this.eventId;

		// reset validation state & inform our container that we're starting a submission
		this.$v.$reset();
		this.submitting = true;

		this.$nextTick(async () => {
			// force re-validation
			this.$v.$touch();

			// if there are validation errors, stop the submission
			if (this.$v.$error) {
				this.submitting = false;
				return;
			}

			var maskRequest = this.alarmMaskRequest;

			if (maskRequest.reason) {
				// get the reason ID
				maskRequest.disarmReasonID = maskRequest.reason.disarmReasonID;
			}

			if (maskRequest.maskType == this.MaskType.MaskUntilDate) {
				// Get the hours and minutes out of the time value
				var momentTime = moment(maskRequest.time, "HH:mm", true);
				var hours = momentTime.hours();
				var minutes = momentTime.minutes();

				// Calculate the datetime when this alarm is to be un-masked, and convert it to UTC
				var formattedDate = moment(this.alarmMaskRequest.maskDate)
					.set({ hours, minutes, seconds: 0 })
					.utc()
					.format();

				// Update the date value within our mask request, set hours and mins to 0
				// (nulls don't work - unsure why, probably because we're posting the form and not a JSON object)
				maskRequest = {
					...maskRequest,
					date: formattedDate,
					hours: 0,
					minutes: 0
				};
			} else {
				delete maskRequest.date;
			}

			try {
				// attempt to mask the alarm
				var result = await this.maskAlarm({maskRequest, regionURL: this.region?.url});
				this.submitting = false;
				this.onMaskedAlarm({
					result: result,
					response: this.maskedAlarm
				});
			} catch (ex) {
				// if we got an error, send it to our parent
				this.onError(ex);
				this.submitting = false;
			}
		});
	}

	/**
	 * Submits an un-mask request to the server.
	 */
	submitUnmask() {
		this.submitting = true;
		this.$nextTick(async () => {
			try {
				await api.unmaskAlarm(this.eventId, this.responseId, this.region?.url);
				this.onUnmaskedAlarm({ response: this.maskedAlarm });
			} catch (ex) {
				this.onError(ex);
			}

			this.submitting = false;
		});
	}

	submit() {
		if (!this.masked) {
			this.submitMask();
		} else {
			this.submitUnmask();
		}
	}

	// == Events == //
	@Emit()
	public onError(message: String) {
		return message;
	}

	@Emit()
	public onMaskedAlarm(maskResult) {
		return maskResult;
	}

	@Emit()
	public onUnmaskedAlarm(result) {
		return result;
	}

	@Emit()
	public onSubmit(value) {
		return value;
	}

	// == Watchers == //

	/**
	 * Adds a blur event listener to the input created by the 'Mask until Date' date picker.
	 * The event handler sets the validation state of the date value to dirty (red underline).
	 */
	@Watch("alarmMaskRequest.maskType")
	onMaskTypeChanged(newVal) {
		if (newVal === this.MaskType.MaskUntilDate) {
			this.$nextTick(() => {
				this.$refs.datePicker.$el.querySelector("input").addEventListener("blur", () => {
					this.$v.alarmMaskRequest.maskDate.$touch();
				});
			});
		}
	}

	/**
	 * Watches the hours value input by the user. Ensures 0 <= input <= 23.
	 */
	@Watch("alarmMaskRequest.hours")
	onHoursChanged(newVal) {
		if (newVal < 0) this.$nextTick(() => (this.alarmMaskRequest.hours = 0));

		if (this.alarmMaskRequest.maskType === this.MaskType.MaskUntilDate) {
			if (newVal > 23) this.$nextTick(() => (this.alarmMaskRequest.hours = 23));
		}
	}

	/**
	 * Watches the minute value input by the user. If the user is masking until a time,
	 * the input is constrained to 0 <= input <= 59. If the user is masking for a set number of minutes,
	 * we make sure they can't enter a negative number.
	 */
	@Watch("alarmMaskRequest.minutes")
	onMinutesChanged(newVal) {
		if (newVal < 0) this.$nextTick(() => (this.alarmMaskRequest.minutes = 0));

		if (this.alarmMaskRequest.maskType === this.MaskType.MaskUntilDate) {
			if (newVal > 59) this.$nextTick(() => (this.alarmMaskRequest.minutes = 59));
		}
	}

	/**
	 * Updates the wrapper component with our submission state.
	 */
	@Watch("submitting")
	onSubmittingStateChanged(newVal) {
		this.onSubmit(newVal);
	}

	/**
	 * If we're in the Mask state, then we need to add a class to the 'Reason' dropdown input
	 * to ensure that when it has focus, our vue-shortkey shortcuts don't fire.
	 * (ie. enter should be used to select an option, not submit the form)
	 */
	@Watch("maskedAlarm")
	onMaskedAlarmChanged(newVal) {
		if (typeof newVal === "undefined") {
			this.$nextTick(() => {
				this.$refs.reasonDropdown.$refs.search.classList.add("prevent-shortcut");
			});
		}
	}

	@Emit("close")
	public close() {
	}
}
